import { render, staticRenderFns } from "./ResourceReview.vue?vue&type=template&id=08275662&scoped=true"
import script from "./ResourceReview.vue?vue&type=script&lang=js"
export * from "./ResourceReview.vue?vue&type=script&lang=js"
import style0 from "./ResourceReview.vue?vue&type=style&index=0&id=08275662&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08275662",
  null
  
)

export default component.exports